//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.MoveBuilder.js";
import "../CAM/CAM.LaserHeadOrientation.js";
let d=[[[0,"DeltaXc",1,0],[0,"DeltaXm",1,0],[0,"DeltaYc",1,0],[0,"DeltaYm",1,0],[0,"DeltaZc",1,0],[0,"DeltaZm",1,0],[0,"Distance",1,0],[1,"HeadOrientation",0,"CAM.LaserHeadOrientation",0],[0,"MotionEnd",1,0],[0,"MoveType",1,0],[0,"Point",1,"Point",0],[0,"RefType",1,0],[0,"Vector",1,"Direction",0]],[],[]];
SPLM.CAM.LaserLinearMove = class extends SPLM.CAM.MoveBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.LaserLinearMove";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.LaserLinearMove.MotionEnds = Object.freeze({
    "Point" : "Point", "Delta" : "Delta", "AlongToolAxis" : "AlongToolAxis", "AlongVector" : "AlongVector"});

SPLM.CAM.LaserLinearMove.MoveTypes = Object.freeze({
    "Direct" : "Direct", "ZmXmYm" : "ZmXmYm", "ZmYmXm" : "ZmYmXm", "XmYmZm" : "XmYmZm", "XmZmYm" : "XmZmYm", "YmZmXm" : "YmZmXm", "YmXmZm" : "YmXmZm"});

SPLM.CAM.LaserLinearMove.RefTypes = Object.freeze({
    "Wcs" : "Wcs", "Mcs" : "Mcs"});

export default SPLM;